import { Input, Button } from "@mantine/core";
import dynamic           from "next/dynamic";
import { useRouter }     from "next/router";

import { useGetDarkMode }   from "_common/hooks/global";
import { useGetDeviceType } from "_common/hooks/global";
import { isPageRoute }      from "_common/utils";
import BackgroundWrapper    from "_components/atoms/backgroundWrapper";
import Render               from "_components/atoms/render";
import {
	useGetGlobalPollsCount,
	useSetOpenChatManagement,
	useSetPollsOpen
} from "_components/pages/studio/states";

const IconsInteractions = dynamic ( () => import ( "./iconsInteractions" ) );
const EmojiDrawer       = dynamic ( () => import ( "./emojiDrawer" ) );
const InputLeftSection  = dynamic ( () => import ( "./inputLeftSection" ) );
const InputRightSection = dynamic ( () => import ( "./inputRightSection" ) );

import useStyles from "./styles";

const component = props => {
	const {
		handleOnChange,
		popOut,
		isStreamer,
		emotesList,
		trottledKeyDown,
		handleLogin,
		handleSendClick,
		disabled,
		placeholderText,
		showTooltipInfoIcon,
		tooltipText,
		handleModal,
		handleToggleEmoji,
		displayEmoji,
		handleEmojiSelect,
		textInput,
		toggleFocusState,
		inputLength,
		isLoggedIn,
		showPolls,
		handleDisabledChatInputClick,
		chatMode
	} = props;

	const { classes }           = useStyles ( { displayEmoji, isStreamer, showTooltipInfoIcon, disabled }, { name: "inputField" } );
	const darkMode              = useGetDarkMode ();
	const router                = useRouter ();
	const togglePolls           = useSetPollsOpen ();
	const setOpenChatManagement = useSetOpenChatManagement ();
	const isStudioPage          = isPageRoute ( { router, page: "studio" } );
	const pollsCount            = useGetGlobalPollsCount ();
	const isPopOutChat          = isPageRoute ( { router, page: "popout" } );

	const deviceType = useGetDeviceType ();

	const isDesktop = deviceType === "desktop";

	const onCopy = e => {
		if ( isStreamer )
			return null;
		if ( router.pathname.includes ( "popOutChat" ) )
			return null;
		e.preventDefault ();
	};

	const onCut = e => {
		if ( isStreamer )
			return null;
		if ( router.pathname.includes ( "popOutChat" ) )
			return null;
		e.preventDefault ();
	};

	const onPaste = e => {
		if ( isStreamer )
			return null;
		if ( router.pathname.includes ( "popOutChat" ) )
			return null;
		e.preventDefault ();
	};

	return (
		<>
			<BackgroundWrapper className = { classes.commentInputContainer }
				type = "secondary"
			>
				<Render condition = { disabled }>
					<Button
						fullWidth
						classNames = { {
							root  : classes.btnRootContainer,
							label : classes.btnLabel
						} }
						justify = "left"
						leftSection = { (
							<Render condition = { showTooltipInfoIcon }>
								<InputLeftSection tooltipText = { tooltipText } />
							</Render>
						) }
						onClick = { () => handleDisabledChatInputClick ( chatMode ) }
						variant = "default"
					>
						{placeholderText}
					</Button>
				</Render>

				<Render condition = { !disabled }>
					<Input
						ref = { textInput }
						autoComplete = "off"
						classNames = { {
							input   : classes.commentRootContainer,
							wrapper : classes.commentInput
						} }
						id = "commentInput"
						leftSectionWidth = { 40 }
						onBlur = { () => textInput?.current?.blur () }
						onChange = { handleOnChange }
						onClick = { handleLogin }
						onCopy = { onCopy }
						onCut = { onCut }
						onFocus = { toggleFocusState }
						onKeyDown = { trottledKeyDown }
						onPaste = { onPaste }
						placeholder = { placeholderText }
						rightSection = { (
							<InputRightSection
								handleSendClick = { handleSendClick }
								inputLength = { inputLength }
							/>
						) }
						rightSectionWidth = { 100 }
						variant = "outline"
					/>
				</Render>

			</BackgroundWrapper>

			<Render condition = { isDesktop }>
				<EmojiDrawer
					displayEmoji = { displayEmoji }
					handleEmojiSelect = { handleEmojiSelect }
				/>

				<IconsInteractions
					darkMode = { darkMode }
					displayEmoji = { displayEmoji }
					emotesList = { emotesList }
					handleLogin = { handleLogin }
					handleModal = { handleModal }
					handleToggleEmoji = { handleToggleEmoji }
					isLoggedIn = { isLoggedIn }
					isPopOutChat = { isPopOutChat }
					isStreamer = { isStreamer }
					isStudioPage = { isStudioPage }
					pollsCount = { pollsCount }
					popOut = { popOut }
					setOpenChatManagement = { setOpenChatManagement }
					showPolls = { showPolls }
					togglePolls = { togglePolls }
				/>
			</Render>
		</>
	);
};

export default component;
